// extracted by mini-css-extract-plugin
export default {"calendar_wrapper":"rv","modify_order":"sv","modify_order_header":"tv","product_details_form_wrapper":"uv","c_wrapper":"vv","save_button":"wv","title":"xv","modify_order_title_wrapper":"yv","note":"zv","buttons_wrapper":"Av"};
    if(module.hot) {
      // 1737143654470
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  